module.exports = __webpack_public_path__ + "img/img-131.4abf7c59.png";